import type { EmbedStoryParams } from './types';

export const DEFAULT_PARAMS: EmbedStoryParams = {
	lazy: true,
	start: 'onload',
	autoHeight: true,
	autoScrollOnCardChange: true,
	autoScrollOffset: 10,
	pageScroll: true,
	aspectRatio: false,
	domain: '',
	urlParams: '',
};

export const SDK_VERSION_PARAM = 'ver';

export const SDK_V2 = '2';
